import './index.scss'
import '../base.css'

import Lottie from 'lottie-web'
import { Toast } from 'vant'

// 动画json，需要UI导出
// eslint-disable-next-line @typescript-eslint/no-var-requires
const data = require('./animate.json')

let count = 1

const container = document.createElement('div')
container.className = 'lottie-success'
const lettie = Lottie.loadAnimation({
  container,
  animationData: data,
  renderer: 'svg',
  loop: false,
  autoplay: false,
  rendererSettings: {
    filterSize: {
      width: '100%',
      height: '100%',
      x: '0',
      y: '0',
    },
  },
})

/**
 * 成功toast
 * @param message 文案
 * @param duration 延迟关闭
 * @param onClose 关闭回调
 * @returns
 */
export default function SubmitSuccessToast (message: string, duration = 2000, onClose?: Function) {
  const currentCount = count

  const idClass = `submit-success-toast--count_${currentCount}`

  count++

  const ins = Toast.success({
    className: `submit-success-toast ${idClass}`,
    message,
    duration,
    overlay: true,
    onOpened: () => {
      const toast = document.getElementsByClassName(idClass).item(0)
      if (toast) {
        const icon = toast.getElementsByTagName('i').item(0)
        icon?.append(container)
        lettie.stop()
        lettie.play()
      }
    },

    // @ts-ignore
    onClose,
  })

  return ins.close as () => void
}
